<template>
  <div id="wrapper">
    <div
      id="content-wrapper"
      class="d-flex flex-column"
    >
      <div id="content">
        <sidebar-menu />
        <div
          id="container-wrapper"
          class="container-fluid"
        >
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SidebarMenu from "@/components/SidebarMenu.vue"; // Now used as horizontal menu with user profile

export default {
  components: {
    SidebarMenu, // Using SidebarMenu component as horizontal navigation with user profile
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
#wrapper {
  display: flex;
  flex-direction: column;
  
  #content-wrapper {
    background-color: #f8f9fc;
    width: 100%;
    overflow-x: hidden;
    min-height: 100vh;
    
    #content {
      flex: 1 0 auto;
    }
  }
  
  .container-fluid {
    padding: 1.5rem 1.5rem;
    margin-top: 10px;
  }
}

@media (max-width: 768px) {
  .container-fluid {
    padding: 1rem 0.75rem;
  }
}

#inspire {
  .v-application {
    background-color: #f8f9fc;
  }
  
  #app {
    text-align: start;
  }
  
  .content {
    padding-top: 116px;
  }
  
  @media (max-width: 768px) {
    .content {
      padding-top: 35px;
      padding-left: 25px;
      padding-right: 25px;
    }
  }
  
  @media (min-width: 1000px) {
    .container--fluid {
      width: 980px;
    }
  }
}
</style>
